import { useEffect, useState } from 'react';
import { getAutoshipDetails } from 'services/autoship';
import { IAutoship } from 'types';

interface IAutoshipDataHookOptions {
  readonly autoshipId: string;
}

export function useAutoshipData(options: IAutoshipDataHookOptions) {
  const [autoshipData, setAutoshipData] = useState<IAutoship>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<unknown>();

  useEffect(() => {
    if (options.autoshipId === undefined) {
      return;
    }

    setLoading(true);

    getAutoshipDetails(options.autoshipId)
      .then(data => {
        setAutoshipData(data);
        setError(undefined);
      })
      .catch(err => {
        setAutoshipData(undefined);
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [options.autoshipId]);

  return {
    autoshipData,
    autoshipDataError: error,
    autoshipDataLoading: loading
  };
}
